import { useCallback } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import {
  MANAGE_SUBS_RESET_CUSTOMER_GROUP_DATA,
} from './constants';

export function resetCustomerGroupData() {
  return {
    type: MANAGE_SUBS_RESET_CUSTOMER_GROUP_DATA,
  };
}

export function useResetCustomerGroupData() {
  const dispatch = useDispatch();
  const customerGroupData = useSelector(state => state.manageSubs.customerGroupData);
  const boundAction = useCallback((...params) => dispatch(resetCustomerGroupData(...params)), [dispatch]);
  return { customerGroupData, resetCustomerGroupData: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_RESET_CUSTOMER_GROUP_DATA:
      return {
        ...state,
        customerGroupData: null,
      };

    default:
      return state;
  }
}
